import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login/Login.css";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../util/constants";

const ResetPassword = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [securityCode, setSeurityCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassowrd] = useState("");
  const [error, setErrors] = useState([]);

  const resetPasswordResponse = useSelector(
    (state) => state.login.resetPasswordResponse
  );

  useEffect(() => {
    if (resetPasswordResponse && resetPasswordResponse != "Failed") {
      navigate("/");
    } else {
      setEmail("");
      setSeurityCode("");
      setPassword("");
      setConfirmPassowrd("");
    }
  }, [resetPasswordResponse]);

  const resetClick = () => {
    let errors = [];
    setErrors(errors);

    if (securityCode === "") {
      errors.push("Please enter security details");
    }

    if (email === "") {
      errors.push("Please enter the Email");
    }

    if (password === "") {
      errors.push("Please enter the Password");
    } else if (password.length > 16) {
      errors.push("Password cannot be longer than 16 characters");
    } else if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(password)) {
      errors.push("Password must contain at least one special character");
    }

    if (confirmpassword === "") {
      errors.push("Please enter the confirm Password");
    } else if (password !== confirmpassword) {
      errors.push("Confirm Password is not the same as Password");
    }

    if (errors.length > 0) {
      setErrors(errors);
    } else {
      setErrors([]);

      const resetPassPayload = {
        verificationCode: securityCode,
        email: email,
        newPassword: password,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_CONFIRM_PASSWORD_API_CALL,
        payload: { value: resetPassPayload },
      });
    }
  };

  return (
    <section>
      <div
        className="page-header col-md-12 tabmargin tab-center"
        style={{
          position: "absolute",
          left: "50%",
          top: "30%",
          transform: "translate(-50%, -50%)",
          height: "60% !important",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-3" style={{ height: "100%" }} />
            <div className="col-md-6 col-6" style={{ height: "100%" }}>
              <div className="card card-plain mt-12">
                <div
                  style={{ width: "100%", padding: 0 }}
                  onClick={() => {
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN
                        .LOGIN_FORGOT_PASSWORD_API_RESPONSE,
                      payload: { value: null },
                    });
                    navigate("/");
                  }}
                  className="form-check"
                >
                  <label className="form-check-label" htmlFor="back">
                    {" "}
                    {`< Back to Login`}
                  </label>
                </div>

                <div className="card-header text-center pt-0 px-lg-2 px-1">
                  <label style={{ fontSize: 16, color: "black" }}>
                    Reset Password
                  </label>
                </div>
                <div
                  className="card-body"
                  style={{ border: "1HN FbFFRT4solid black !important" }}
                >
                  <form role="form">
                    <label>Email</label>
                    <div className="mb-3">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        aria-label="Email"
                        aria-describedby="email-addon"
                        maxLength={50}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        value={email}
                      />
                    </div>

                    <label>Security Code </label>
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Security Code"
                        onChange={(e) => {
                          setSeurityCode(e.target.value);
                        }}
                        value={securityCode}
                      />
                    </div>

                    <label>New Password</label>
                    <div className="mb-3">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        maxLength={30}
                        aria-describedby="password-addon"
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                        value={password}
                      />
                    </div>

                    <label>Confirm Password</label>
                    <div className="mb-3">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        aria-label="Password"
                        maxLength={30}
                        aria-describedby="password-addon"
                        onChange={(e) => {
                          setConfirmPassowrd(e.target.value);
                        }}
                        value={confirmpassword}
                      />
                    </div>
                    <label style={{ fontSize: 12, color: "red" }}> Password must contain at least one special character and maximum length should be 16 characters</label>
                    {error && error?.length > 0 &&  <div class="alert alert-danger text-white" role="alert">
                        <ul>
  {error.map((data)=><li>{data}</li>)}
  </ul>
</div>}

                    <div className="text-center" style={{}}>
                      <button
                        type="button"
                        className="btn col-md-4"
                        style={{
                          borderRadius: 4,
                          borderColor: "#17a2b8",
                          color: "white",
                          background: "linear-gradient(300deg,#2152ff,#21d4fd)",
                        }}
                        onClick={() => {
                          resetClick();
                        }}

                      >
                        Reset Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-3" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
